<template>
  <div class="page">
    <div class="inner">
      <access-denied-error/>
    </div>
  </div>
</template>

<script>
import AccessDeniedError from '../errors/AccessDeniedError.vue'
export default {
  name: 'AccessDeniedPage',
  components: {
    AccessDeniedError
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/AccessDeniedPage.vue